import commonPostTypeConfig from '../../common/postTypes/subscribe'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'subscribe',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
